import React, { useEffect, useRef, useState } from 'react';
import { OptionProps, SelectPropsData, TextPropsData } from '../../../../view-models';
import { StringFormatSelectorComponent } from './stringFormat';
import { claimFunctions } from '../../../../jsonParsing/mappedClaimTransforms/mappedClaimTransforms';

interface ClaimFunctionSelectorProps {
    data: any;
    transformFieldName: string;
    claimFunction: string;
    claimsList: OptionProps[];
    allClaims: any;
    writeback: (data: any) => void;
}

export const ClaimFunctionSelectorComponent = ({
    data,
    transformFieldName,
    claimFunction,
    claimsList,
    allClaims,
    writeback
}: ClaimFunctionSelectorProps) => {
    return <>
        {claimFunction === claimFunctions.stringFormat && (
            <StringFormatSelectorComponent
                data={data[transformFieldName]}
                claimsList={claimsList.filter(claimOptProp => { return (!allClaims) || allClaims[claimOptProp.value].dataType === 'string'})}
                writeback={(wbData) => {
                    writeback({
                        ...data,
                        [transformFieldName]: wbData
                    })
                }}
                inputClaim1FieldName='inputClaim0'
                inputClaim2FieldName='inputClaim1'
                formatStringFieldName='formatString'
            />
        )}
    </>
}